// extracted by mini-css-extract-plugin
module.exports = {"editButton":"Item_editButton__lW1B4","labelButton":"Item_labelButton__3J-Pl","labelButtonActive":"Item_labelButtonActive__1T8Ne","wrapper":"Item_wrapper__2rZPD"};